// import { motion } from "framer-motion";
import { useState } from "react";
// import { ArrowRight, Section } from "lucide-react";
import EnrollSection from "./EnrollSection";
import Navbar from "./Navbar";
import fullStackImg from "../assets/courses/full-stack.jpg";
import pythonImg from "../assets/courses/python.jpg";
import javaImg from "../assets/courses/java.jpg";
import cppImg from "../assets/courses/c-plus.jpg";
import dcaImg from "../assets/courses/dca.jpg";
import graphicImg from "../assets/courses/graphic.jpg";
import tallyImg from "../assets/courses/tally.jpg";
import digitalImg from "../assets/courses/digital.jpg";
import { FaStar, FaClock, FaLaptopCode, FaUserGraduate } from "react-icons/fa";
import EnrollModal from "./EnrollModal";

const courses = [

  {
    image: fullStackImg,
    title: "Full Stack Development",
    category: "Best Seller",
    description:
      "Become a Full Stack Developer by learning HTML, CSS, JavaScript, React, Node.js, Express and MongoDB.",

    skills: ["HTML", "CSS", "JavaScript", "React", "Node", "MongoDB"],

    duration: "3 Months",
    mode: "Online",
    students: "500",
    price: "₹18,000",
  },

  {
    image: pythonImg,
    title: "Python Programming",
    category: "Trending",

    description:
      "Master Python programming for Automation, Data Science, AI and Web Development.",

    skills: ["Python", "Django", "Flask", "Pandas", "NumPy"],

    duration: "2 Months",
    mode: "Offline",
    students: "350",
    price: "₹12,000",
  },

  {
    image: javaImg,
    title: "Java Programming",
    category: "Popular",

    description:
      "Learn Core Java, Advanced Java, Spring Boot and build enterprise applications.",

    skills: ["Java", "Spring", "JDBC", "Hibernate"],

    duration: "3 Months",
    mode: "Online",
    students: "420",
    price: "₹15,000",
  },

  {
    image: cppImg,
    title: "Programming in C & C++",
    category: "Popular",

    description:
      "Core building blocks of programming, essential for strong logic development.",

    skills: ["C", "C++", "Data Structures", "Algorithms"],

    duration: "3 Months",
    mode: "Online",
    students: "350+",
    price: "₹12,000",
  },

  {
    image: dcaImg,
    title: "DCA – Diploma in Computer Applications",
    category: "Popular",

    description:
      "Perfect for beginners entering IT or office-related careers.",

    skills: ["MS Office", "Windows", "Internet Basics", "Operating Systems"],

    duration: "6 Months",
    mode: "Online & Offline",
    students: "500+",
    price: "₹10,000",
  },

  {
    image: graphicImg,
    title: "Graphic Designing",
    category: "Trending",

    description:
      "Learn professional design, branding, and creative tools used in media industries.",

    skills: ["Photoshop", "Illustrator", "InDesign", "CorelDraw"],

    duration: "4 Months",
    mode: "Online & Offline",
    students: "280+",
    price: "₹15,000",
  },

  {
    image: tallyImg,
    title: "Tally & Accounting",
    category: "Popular",

    description:
      "An industry-focused program for accounting careers.",

    skills: ["Tally Prime", "GST", "Taxation", "Bookkeeping"],

    duration: "3 Months",
    mode: "Online",
    students: "320+",
    price: "₹9,000",
  },

  {
    image: digitalImg,
    title: "Digital Marketing",
    category: "Best Seller",

    description:
      "A complete digital marketing program for business growth, freelancing, and agency careers.",

    skills: [
      "SEO",
      "SEM",
      "SMM",
      "Content Marketing",
      "Analytics",
    ],

    duration: "4 Months",
    mode: "Online & Offline",
    students: "450+",
    price: "₹18,000",
  },


];

export default function CoursesSection() {

  const [open, setOpen] = useState(false);

  const CourseCard = ({ course }) => {
    return (
      <div className="group bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-gray-200">
        {/* Course Image */}
        <div className="relative overflow-hidden">
          <img
            src={course.image}
            alt={course.title}
            className="w-full h-56 object-cover group-hover:scale-110 transition duration-500"
          />

          <span className="absolute top-4 left-4 bg-blue-600 text-white text-xs px-3 py-1 rounded-full font-semibold">
            {course.category}
          </span>
        </div>

        {/* Content */}
        <div className="p-6">
          {/* Title */}
          <h2 className="text-2xl font-bold text-gray-800 mb-3">
            {course.title}
          </h2>

          {/* Rating */}
          <div className="flex items-center text-yellow-400 mb-3">
            <FaStar />
            <FaStar />
            <FaStar />
            <FaStar />
            <FaStar />

            <span className="ml-2 text-gray-600 font-medium">(4.9)</span>
          </div>

          {/* Description */}
          <p className="text-gray-600 leading-7 text-sm mb-5">
            {course.description}
          </p>

          {/* Technologies */}
          <div className="flex flex-wrap gap-2 mb-5">
            {course.skills.map((skill, index) => (
              <span
                key={index}
                className="bg-blue-100 text-primary text-xs px-3 py-1 rounded-full font-medium"
              >
                {skill}
              </span>
            ))}
          </div>

          {/* Course Info */}

          <div className="space-y-3 border-t border-b py-4">
            <div className="flex justify-between">
              <div className="flex items-center text-gray-600">
                <FaClock className="mr-2 text-blue-600" />

                {course.duration}
              </div>

              <div className="flex items-center text-gray-600">
                <FaLaptopCode className="mr-2 text-blue-600" />

                {course.mode}
              </div>
            </div>

            <div className="flex justify-between">
              <div className="flex items-center text-gray-600">
                <FaUserGraduate className="mr-2 text-blue-600" />
                {course.students}+
              </div>

              <div className="font-semibold text-green-600">Job Assistance</div>
            </div>
          </div>

          {/* Price */}

          {/* <div className="mt-6 bg-gray-50 rounded-xl p-4">
            <div className="flex justify-between items-center">
              <div>
                <p className="text-gray-500 text-sm">Course Fee</p>

                <h2 className="text-3xl font-bold text-primary">
                  {course.price}
                </h2>
              </div>

              <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm font-semibold">
                Free Demo
              </span>
            </div>
          </div> */}

          {/* Buttons */}

          <div className="grid grid-cols-2 gap-3 mt-6">
           {/* <button className="border-2 border-blue-600 text-blue-600 py-3 rounded-xl font-semibold hover:bg-blue-600 hover:text-white transition">
              View Details
            </button>*/}

            <button
              onClick={() => setOpen(true)}
              className="bg-blue-600 text-white py-3 rounded-xl font-semibold hover:bg-blue-700 transition">
              Enroll Now
            </button>
          </div>
          
        </div>
      </div>
    );
  };

  return (
    <>
      <Navbar />

      <section className="bg-gray-100 py-5">
        <div className=" mx-auto px-10 py-5">
          <div className="text-center mb-14">
            <h2 className="text-5xl font-bold text-primary py-4">
              Our Popular Courses
            </h2>

            <p className="text-gray-600 mt-4 text-lg">
              Practical Training • Industry Experts • Placement Assistance
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {courses.map((course, index) => (
              <CourseCard key={index} course={course} />
            ))}
          </div>
        </div>
      </section>

      <EnrollSection />


      {/* <Section>
              <section className="w-full py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
            className="max-w-3xl mb-14"
          >
            <h2 className="text-4xl font-bold text-[#005598] mb-4">
              Courses We Offer at MSM Technologies
            </h2>
            <p className="text-gray-600 leading-relaxed">
              At <strong>MSM Technologies</strong>, every course is designed
              with one strong objective:
              <br />
              <strong>
                “Make every learner job-ready with practical, real-time
                training.”
              </strong>
            </p>
          </motion.div>

          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {courses.map((course, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="border border-[#005598] rounded-2xl p-6 relative hover:shadow-xl transition-all duration-300 group"
              >
                <div className="flex justify-between items-start gap-4">
                  <div>
                    <h3 className="text-lg font-semibold text-[#005598] mb-2">
                      {course.title}
                    </h3>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      {course.desc}
                    </p>
                  </div>

                  <img
                    src={course.img}
                    alt={course.title}
                    className="w-20 h-20 object-cover rounded-xl"
                  />
                </div>

                
                <button className="absolute bottom-4 left-4 w-9 h-9 rounded-full bg-[#005598] text-white flex items-center justify-center group-hover:translate-x-1 transition-transform">
                  <ArrowRight size={18} />
                </button>
              </motion.div>
            ))}
          </div>

          
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
            className="mt-16 border border-[#005598] rounded-xl p-6 text-center"
          >
            <p className="text-[#005598] font-semibold">
              Full Stack / Programming / Soft Skills – IT Combo Courses
            </p>
            <p className="text-sm text-gray-600 mt-2">
              MSM Technologies offers customized combo packs based on student
              goals
            </p>
          </motion.div>
        </div>
      </section>
            </Section> */}

        <EnrollModal
            open={open}
            onClose={() => setOpen(false)}
            course="React JS Development"
          />


    </>
  );
}
